import { useState, useEffect, React, useMemo, useRef } from 'react'
import Empty from 'general/components/Empty'
import { Modal, Button, Accordion, ListGroup } from 'react-bootstrap'
import { FastField, Formik, useFormik } from 'formik'
import * as Yup from 'yup'
import ToastHelper from 'general/helpers/ToastHelper'
import KTFormGroup from 'general/components/Forms/KTFormGroup'
import KTFormInput, {
  KTFormInputType,
} from 'general/components/Forms/KTFormInput'
import KTRadio from 'general/components/Forms/KTFormControls/KTRadio'
import KTFormSearchDropDown from 'general/components/Forms/KTFormSearchDropDown'
import KTCheckbox from 'general/components/Forms/KTFormControls/KTCheckbox'
import _ from 'lodash'
import { unwrapResult } from '@reduxjs/toolkit'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import AppData from 'general/constants/AppData'
import DataTable from 'react-data-table-component'
import customDataTableStyle from 'assets/styles/customDataTableStyle'
import Loading from 'general/components/Loading'
import AppResource from 'general/constants/AppResource'
import KeenSearchBarNoFormik from 'general/components/KeenSearchBarNoFormik'
import { updateAllListFunction } from '../../functionSlice'
import templateInvoiceApi from 'api/templateInvoiceApi'
import Utils from 'general/utils/Utils'
import './style.scss'
import { setAppSpinning } from 'app/appSlice'

function UpdateUserModal(props) {
  const {
    show,
    setShow,
    onRefreshCustomerList,
    user,
    onExistDone,
    addUserFunction,
    templateInvoiceSerialsTmp,
  } = props
  const [showBx, setShowBx] = useState(true)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isEditMode, setIsEditMode] = useState(true)
  const [activities, setActivities] = useState([])

  const [tableMaxHeight, setTableMaxHeight] = useState('55vh')
  const { customers, isGettingCustomer, pagination } = useSelector(
    (state) => state?.category,
  )
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [toggleClearCustomers, setToggledClearCustomers] = useState(true)
  const [selectedCustomerItem, setSelectedCustomerItem] = useState(null)
  const [showingModalEditCustomer, setShowingModalEditCustomer] =
    useState(false)
  const refCsvFile = useRef()
  const [csvImporting, setCsvImporting] = useState(false)
  const [templateInvoiceSerials, setTemplateInvoiceSerials] = useState([])

  const [userFunction, setUserFunction] = useState(
    useSelector((state) => state?.function?.userFunctions),
  )

  const [listFunction, setListFunction] = useState(
    useSelector((state) =>
      state?.function?.listFunctions.map((item) => ({ ...item, active: 1 })),
    ),
  )

  const [dataFunctionList, setDataFunctionList] = useState([])

  useEffect(() => {
    if (userFunction) {
      const filteredFunctions = userFunction.filter(
        (item) => item.type === 'parent',
      )
      const newFunctionList = filteredFunctions.map((item) => ({
        name: item.functionName,
        userFunctionId: item.userFunctionId,
      }))

      const updatedDataFunctionList = newFunctionList.map((parentItem) => {
        const childFunctions = userFunction.filter(
          (item) =>
            item.type === 'children' &&
            item.parentId === parentItem.userFunctionId,
        )
        const childList = childFunctions.map((childItem) => ({
          name: childItem.functionName,
          userFunctionId: childItem.userFunctionId,
        }))

        const activities = listFunction.filter(
          (item) => item.userFunctionId === parentItem.userFunctionId,
        )

        const updatedChildList = childList.map((childItem) => {
          const childActivities = listFunction.filter(
            (item) => item.userFunctionId === childItem.userFunctionId,
          )
          return { ...childItem, activities: childActivities }
        })

        return { ...parentItem, list: updatedChildList, activities }
      })

      if (dataFunctionList == [])
        setDataFunctionList((prevList) => [
          ...prevList,
          ...updatedDataFunctionList,
        ])
      else setDataFunctionList(updatedDataFunctionList)
    }
  }, [userFunction, listFunction])

  useEffect(() => {
    setTemplateInvoiceSerials(templateInvoiceSerialsTmp)
  }, [templateInvoiceSerialsTmp])

  const fullColumns = [
    {
      name: 'Tên mẫu',
      cell: (row) => {
        return <div data-tag="allowRowEvents">{row?.name}</div>
      },
    },
    {
      name: 'Mẫu số - Ký hiệu',
      // sortable: false,
      // minWidth: '220px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.serial}
          </p>
        )
      },
    },
    {
      name: 'Ngừng sử dụng',
      center: true,
      cell: (row) => {
        return (
          <div data-tag="allowRowEvents" className="text-center w-100">
            {row?.active == 1 ? (
              <i className="fa-solid fa-circle-minus"></i>
            ) : (
              <i
                style={{ color: 'red' }}
                className="fa-solid fa-circle-minus"
              ></i>
            )}
          </div>
        )
      },
    },
  ]

  const columns = fullColumns

  function handleExistDone() {
    if (onExistDone) {
      onExistDone()
    }
  }

  const changeListFunction = (id) => {
    const tmp = ['Xem danh sách', 'Xem']
    let view = null
    let restList = []
    let prevListFunction = [...listFunction]
    let prevActivities = [...activities]

    prevActivities.map((item) => {
      if (tmp.includes(item.actionName)) {
        view = item
      } else {
        restList.push(item)
      }
    })

    const targetItem = prevActivities.find(
      (activity) => activity.listFunctionId == id,
    )

    if (restList == [] || view == null) {
      setActivities((prevList) => {
        return prevList.map((item) => {
          if (item == targetItem) {
            return { ...item, active: !item.active }
          }
          return item
        })
      })
      setListFunction((prevList) => {
        return prevList.map((item) => {
          if (item == targetItem) {
            return { ...item, active: !item.active }
          }
          return item
        })
      })
      return
    }
    if (targetItem == view) {
      if (view.active == 1) {
        prevListFunction = prevListFunction.map((item) => {
          if (restList.some((restItem) => restItem == item) || item == view) {
            return { ...item, active: 0 }
          }
          return item
        })

        prevActivities = prevActivities.map((item) => {
          if (restList.some((restItem) => restItem == item) || item == view) {
            return { ...item, active: 0 }
          }
          return item
        })
      } else {
        prevListFunction = prevListFunction.map((item) => {
          if (item == view) {
            return { ...item, active: 1 }
          }
          return item
        })

        prevActivities = prevActivities.map((item) => {
          if (item == view) {
            return { ...item, active: 1 }
          }
          return item
        })
      }
    } else if (restList.some((item) => item == targetItem)) {
      prevListFunction = prevListFunction.map((item) => {
        if (item == view && targetItem.active == 0) {
          return { ...item, active: 1 }
        } else {
          if (item == targetItem) {
            return { ...item, active: !item.active }
          }
        }
        return item
      })

      prevActivities = prevActivities.map((item) => {
        if (item == view) {
          return { ...item, active: 1 }
        } else {
          if (item == targetItem) {
            return { ...item, active: !item.active }
          }
        }
        return item
      })
    }

    prevListFunction.forEach(function (item) {
      if (
        prevActivities.some(
          (activity) => activity.listFunctionId == item.listFunctionId,
        )
      ) {
      }
    })

    setActivities(prevActivities)
    setListFunction(prevListFunction)
  }

  const companyTmp = useSelector((state) => state.auth.currentCompany)
  const [company, setCompany] = useState(companyTmp)

  const [userRole, setUserRole] = useState('Quản trị')

  useEffect(() => {
    setCompany(companyTmp)
  }, [companyTmp])

  const selectedRows = useRef()
  const defaultSelectedRows = (row) => {
    // if (userRole === 'Quản trị') {
    //   return row;
    // } else {
    // }
    return ''
  }

  const handleSelectedRowsChange = (rows) => {
    selectedRows.current = rows.selectedRows
    // console.log(selectedRows.current);
  }

  const checkFullFunction = (item1) => {
    // console.log(item1);
    if (item1?.activities?.length > 0) {
      const allActiveIs1InActivities = item1.activities.every(
        (activity) => activity.active == 1,
      )
      if (allActiveIs1InActivities) {
        return '(Toàn quyền)'
      } else {
        return ''
      }
    } else {
      if (item1?.list?.length > 0) {
        if (item1?.list?.length > 0) {
          const allActiveIs1 = item1.list.every((obj) => {
            return obj.activities.every((activity) => activity.active == 1)
          })

          if (allActiveIs1) {
            return '(Toàn quyền)'
          }
        }
        return ''
      }
    }
  }

  const companyUnitsTmp = useSelector((state) => state?.category?.companyUnits)

  const [companyUnits, setCompanyUnits] = useState()

  useEffect(() => {
    // Kiểm tra nếu companyUnits không null và có phần tử trong mảng
    if (companyUnitsTmp && companyUnitsTmp.length > 0) {
      // Tạo một bản sao của companyUnits đã có để tránh sửa trực tiếp vào state Redux
      const updatedCompanyUnits = companyUnitsTmp.map((item) => ({
        ...item,
        value: item.name, // Thêm trường value và gán bằng giá trị của trường name
      }))

      // Cập nhật lại companyUnits trong state Redux bằng mảng đã được thêm trường value
      setCompanyUnits(updatedCompanyUnits)
    }
  }, [companyUnitsTmp])

  const companyTitlesTmp = useSelector(
    (state) => state?.category?.companyTitles,
  )

  const [companyTitles, setCompanyTitles] = useState()

  useEffect(() => {
    // Kiểm tra nếu companyTitles không null và có phần tử trong mảng
    if (companyTitlesTmp && companyTitlesTmp.length > 0) {
      // Tạo một bản sao của companyTitles đã có để tránh sửa trực tiếp vào state Redux
      const updatedCompanyTitles = companyTitlesTmp
        .filter((_item) => _item.status === 'ACTIVE')
        .map((item) => ({
          ...item,
          value: item.name, // Thêm trường value và gán bằng giá trị của trường name
        }))

      // Cập nhật lại companyTitles trong state Redux bằng mảng đã được thêm trường value
      setCompanyTitles(updatedCompanyTitles)
    }
  }, [companyTitlesTmp])

  return (
    <div className="UpdateUserModal">
      <Formik
        initialValues={{
          title: companyTitles ? companyTitles[0].value : '',
          fullname: user ? user.fullname : '',
          agency: companyUnits ? companyUnits[0].value : '',
          role: 'Người dùng', // Include the role field
          email: user ? user.email : '',
          phone: user ? user?.phone : '',
        }}
        validationSchema={Yup.object({
          fullname: Yup.string().required('Không được để trống').trim(),
          phone: Yup.string().required('Không được để trống'),
          email: Yup.string()
            .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Email không hợp lệ')
            .required('Không được để trống'),
        })}
        enableReinitialize
        onSubmit={async (values) => {
          dispatch(setAppSpinning(true))
          try {
            await addUserFunction(values, listFunction, selectedRows.current)
          } catch (error) {
            console.error(error)
            // Bạn có thể muốn xử lý lỗi ở đây
          } finally {
            dispatch(setAppSpinning(false))
          }
        }}
      >
        {(formikProps) => (
          <div style={{ minWidth: '800px' }}>
            <Modal
              className=""
              show={show}
              backdrop="static"
              size="lg"
              onHide={handleClose}
              centered
              onExit={() => {
                formikProps.handleReset()
              }}
              onExited={() => {
                handleExistDone()
              }}
            >
              <Modal.Header className="px-5 py-5">
                <Modal.Title>Thêm người dùng</Modal.Title>
                <div
                  className="btn btn-xs btn-icon btn-light btn-hover-secondary cursor-pointer"
                  onClick={() => {
                    handleClose()
                  }}
                >
                  <i className="far fa-times"></i>
                </div>
              </Modal.Header>

              <Modal.Body
                className="bg-light"
                style={{
                  maxHeight: '70vh',
                  zIndex: 100,
                  overflowY: 'inherit !important',
                  padding: '10px 20px',
                }}
              >
                <div className="row">
                  <div className="col-lg-6 pr-lg-3">
                    <KTFormGroup
                      label={
                        <>
                          {t('Email')} <span className="text-danger">(*)</span>
                        </>
                      }
                      inputName="email"
                      inputElement={
                        <FastField name="email">
                          {({ field, form, meta }) => (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value)
                              }}
                              onFocus={() => {
                                form.setFieldTouched(field.name, true)
                              }}
                              enableCheckValid
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                              type={KTFormInputType.text}
                              placeholder={`${_.capitalize(t('Email'))}...`}
                              // disabled={!canEdit}
                            />
                          )}
                        </FastField>
                      }
                    />
                  </div>

                  {/* Quyền truy cập*/}
                  {/* <div className="mb-4 d-flex flex-column col-lg-6">
                    <label
                      className="mb-2 font-weight-bolder"
                      style={{ color: '#7177A8' }}
                      htmlFor="role"
                    >
                      {_.capitalize(t('Quyền truy cập'))} <span className="text-danger">(*)</span>
                    </label>
                    <KTFormSearchDropDown
                      name="role"
                      isCustom
                      options={AppData.userRole}
                      value={formikProps.getFieldProps('role').value?.toString()}
                      onChange={(newValue) => {
                        setUserRole(newValue);
                        formikProps.getFieldHelpers('role').setValue(newValue);
                      }}
                    />
                  </div> */}

                  <div className="mb-4 d-flex flex-column col-lg-6">
                    <label
                      className="mb-2 font-weight-bolder"
                      style={{ color: '#7177A8' }}
                      htmlFor="title"
                    >
                      {_.capitalize(t('Chức danh'))}
                    </label>
                    <KTFormSearchDropDown
                      name="title"
                      noSearchBar={true}
                      isCustom
                      options={companyTitles}
                      value={formikProps
                        .getFieldProps('title')
                        .value?.toString()}
                      onChange={(newValue) => {
                        formikProps.getFieldHelpers('title').setValue(newValue)
                      }}
                    />
                  </div>

                  {/* so dien thoai */}
                  <div className="col-lg-6">
                    <KTFormGroup
                      label={
                        <>
                          {t('Số điện thoại')}{' '}
                          <span className="text-danger">(*)</span>
                        </>
                      }
                      inputName="phone"
                      inputElement={
                        <FastField name="phone">
                          {({ field, form, meta }) => (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value)
                              }}
                              onFocus={() => {
                                form.setFieldTouched(field.name, true)
                              }}
                              enableCheckValid
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                              type={KTFormInputType.text}
                              placeholder={`${_.capitalize(
                                t('Số điện thoại'),
                              )}...`}
                              // disabled={!canEdit}
                            />
                          )}
                        </FastField>
                      }
                    />
                  </div>

                  {/* Đơn vị */}
                  <div className="mb-4 d-flex flex-column col-lg-6">
                    <label
                      className="mb-2 font-weight-bolder"
                      style={{ color: '#7177A8' }}
                      htmlFor="title"
                    >
                      {_.capitalize(t('Đơn vị'))}
                    </label>
                    <KTFormSearchDropDown
                      name="title"
                      noSearchBar={true}
                      isCustom
                      options={companyUnits}
                      value={formikProps
                        .getFieldProps('agency')
                        .value?.toString()}
                      onChange={(newValue) => {
                        formikProps.getFieldHelpers('agency').setValue(newValue)
                      }}
                    />
                  </div>

                  {/* Họ và tên*/}
                  <div className="col-lg-6 d-flex">
                    <div className="w-100 pr-3">
                      <KTFormGroup
                        label={
                          <>
                            {t('Họ và tên')}{' '}
                            <span className="text-danger">(*)</span>
                          </>
                        }
                        inputName="fullname"
                        inputElement={
                          <FastField name="fullname">
                            {({ field, form, meta }) => (
                              <KTFormInput
                                name={field.name}
                                value={field.value}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value)
                                }}
                                onFocus={() => {
                                  form.setFieldTouched(field.name, true)
                                }}
                                enableCheckValid
                                isValid={_.isEmpty(meta.error)}
                                isTouched={meta.touched}
                                feedbackText={meta.error}
                                type={KTFormInputType.text}
                                placeholder={`${_.capitalize(
                                  t('Họ và đệm'),
                                )}...`}
                                // disabled={!canEdit}
                              />
                            )}
                          </FastField>
                        }
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer style={{ zIndex: 90, padding: '0px' }}>
                <div
                  className="w-100 d-flex cursor-pointer"
                  style={{ padding: '10px 20px' }}
                >
                  <div
                    className="pr-5"
                    style={{
                      color: `${showBx == true ? '#1877F2' : '#3F4254'}`,
                      borderBottom: showBx == true && '1px solid #1877F2',
                    }}
                    onClick={() => {
                      setShowBx(true)
                    }}
                  >
                    Phân quyền chức năng
                  </div>
                  <div
                    className="pr-5"
                    style={{
                      color: `${showBx == false ? '#1877F2' : '#3F4254'}`,
                      borderBottom: showBx == false && '1px solid #1877F2',
                    }}
                    onClick={() => {
                      setShowBx(false)
                    }}
                  >
                    Phân quyền mẫu hóa đơn
                  </div>
                </div>
                <div className="w-100 m-0">
                  {showBx ? (
                    <div className="row w-100 m-0">
                      <div
                        className="w-100 d-flex pt-3 pb-3 pl-5 pr-5 mb-2"
                        style={{ background: '#F4F5F8' }}
                      >
                        <div className="w-50">Chức năng</div>
                        <div className="w-50">Hoạt động của chức năng</div>
                      </div>
                      <div
                        className="col-lg-6"
                        style={{ maxHeight: '300px', overflow: 'auto' }}
                      >
                        <Accordion>
                          {dataFunctionList?.map((item1, index1) => {
                            return (
                              <Accordion.Item eventKey={index1} key={index1}>
                                <Accordion.Header
                                  className={
                                    item1?.list.length > 0 ? '' : 'no-arrow'
                                  }
                                  onClick={() => {
                                    if (item1?.activities)
                                      setActivities(item1?.activities)
                                  }}
                                >
                                  <div>
                                    {item1?.name}
                                    <span
                                      className="pl-1"
                                      style={{ color: 'red' }}
                                    >
                                      {checkFullFunction(item1)}
                                    </span>
                                  </div>
                                </Accordion.Header>
                                {item1?.list.length > 0 && (
                                  <Accordion.Body>
                                    <ListGroup>
                                      {item1?.list.map((item2, index2) => {
                                        return (
                                          <div key={index2}>
                                            <ListGroup.Item
                                              action
                                              className="pl-5 w-100 mt-2"
                                              onClick={() => {
                                                if (item2?.activities)
                                                  setActivities(
                                                    item2?.activities,
                                                  )
                                              }}
                                            >
                                              <div>
                                                {item2?.name}
                                                <span
                                                  className="pl-1"
                                                  style={{ color: 'red' }}
                                                >
                                                  {checkFullFunction(item2)}
                                                </span>
                                              </div>
                                            </ListGroup.Item>
                                          </div>
                                        )
                                      })}
                                    </ListGroup>
                                  </Accordion.Body>
                                )}
                              </Accordion.Item>
                            )
                          })}
                        </Accordion>
                      </div>

                      <div
                        className="col-lg-6"
                        style={{ maxHeight: '400px', overflow: 'auto' }}
                      >
                        {activities?.map((item, index) => {
                          return (
                            <div className="mt-3" key={index}>
                              <KTCheckbox
                                label={item?.actionName}
                                checked={item?.active}
                                onChange={() =>
                                  changeListFunction(item?.listFunctionId)
                                }
                              ></KTCheckbox>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  ) : (
                    <div style={{ maxHeight: '345px', overflow: 'auto' }}>
                      <DataTable
                        fixedHeader
                        fixedHeaderScrollHeight={tableMaxHeight}
                        columns={columns}
                        data={templateInvoiceSerials}
                        customStyles={customDataTableStyle}
                        responsive={true}
                        noHeader
                        selectableRows={true}
                        striped
                        noDataComponent={
                          <div className="pt-12">
                            <Empty
                              text={t('NoData')}
                              visible={false}
                              imageEmpty={AppResource.icons.icEmptyBox}
                              imageEmptyPercentWidth={170}
                            />
                          </div>
                        }
                        progressComponent={
                          <Loading
                            showBackground={false}
                            message={`${t('Loading')}...`}
                          />
                        }
                        clearSelectedRows={toggleClearCustomers}
                        pointerOnHover
                        highlightOnHover
                        selectableRowsHighlight
                        onSelectedRowsChange={handleSelectedRowsChange}
                        selectableRowSelected={defaultSelectedRows}
                      />
                    </div>
                  )}
                </div>
                <div className="w-100 d-flex row">
                  <Button
                    className="font-weight-bold flex-grow-1 col mr-3"
                    variant="secondary"
                    onClick={() => {
                      handleClose()
                    }}
                  >
                    {t('Đóng')}
                  </Button>
                  <Button
                    className="font-weight-bold flex-grow-1 col"
                    variant="primary"
                    onClick={() => {
                      formikProps.handleSubmit()
                    }}
                  >
                    {t('Lưu')}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </Formik>
    </div>
  )
}

export default UpdateUserModal
